module.exports = __webpack_public_path__ + "static/media/etenders_square_only.256b3611.jpg";